import React, {Component} from "react"
import {observer} from "mobx-react"
import PropTypes from "prop-types"
import {Link} from "react-router-dom"
import {Card, Icon, Button, Input, Label} from "semantic-ui-react"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import shop from "shop/shop"
import "components/Product/ProductCard.scss"
import ImageWithFallback from "components/ImageWithFallback"
import queryString from "qs"

@observer
class ProductCard extends Component {

	render() {
		let {product, categoryId = "", referrer, query = {}, price = true} = this.props
		const inCart = shop.cart.productsById.get( product.map_id ) || product
		const useQuickorder = shop.config.plugin.orderFromTile && shop.session
		const showPrice = shop.session

		return (
			<Card
				className="product ProductCard">
				<div className="wrapper">
					<Link className="product-inner"
						  to={`/product/${product.map_id}/?${queryString.stringify( {category: categoryId, referrer, ...query} )}`}>
						<div className="image flex items-center justify-center">
							<ImageWithFallback src={product.img_src_medium}
											   alt="..."
											   title=""
											   className="img-responsive" />
						</div>
						<div className="caption ">
							<div className="title" title={product.desc.short_des}>{product.title}</div>
							<div className="art-nr black-50">#{product.article_nr}</div>
							<div className="category black-50 f6" title={product.category.title}>
								{product.extras.Groesse} <br />
								{product.extras.Farbe}
							</div>

							<div className="actions">
								{(this.props.list) ? <ButtonLove list={this.props.list}
																 product={product}><Icon name={"heart"} /></ButtonLove> : null} </div>

						</div>
					</Link>
					{this.props.children}
					<div className="badges absolute right-1 top-1 black-50 tr">
						{product.isSale && <div className="pb2"><Label color="red">SALE</Label></div>}
						{shop.config.useAvailability !== false && <div className="availability">{product.getNotice( "tiny" )}</div>}
					</div>

					{showPrice ? <div>
						<div className="absolute right-1 bottom-1">
							<ButtonLove list={shop.orderlist.default}
										className="dib mr3"
										elementInActive={<span><Icon name={"heart"} /></span>}
										elementActive={<span><Icon name={"heart"} /></span>}
										product={product} />
							<Button primary className="" basic onClick={() => {
								if ( product.count ) {
									product.count += 1
								} else {
									product.count = 1
								}
								shop.cart.add( product )
								shop.toast( `${product.count}x ${product.title} ${translate("Im Warenkorb")}`, "info", false, "bottom" )
							}}>
								<Icon name="cart" />
								{product.unit_multi} Stk.
							</Button>
						</div>
						{product.isSale &&
						<div className="price absolute bottom-1 left-1 color" title={translate( "Stückpreis" )}>
							{/*<span className="unit_multi black-70 f6 pb2 fw2">Stückpreis</span><br/>*/}
							{/*<span className="f5 black-60 strike"><Price>{product.price * 1.12}</Price></span> <br />*/}
							<span className="f4 red b"><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.price}</Price></span>
						</div>}
						{!product.isSale &&
						<div className="price absolute bottom-1 left-1 color">
							<span className="unit_multi black-70 f6 pb2 fw2">{translate( "Stückpreis" )}</span><br />
							<span className="f4  b"><Price currency={shop.session.value.currency ? shop.session.value.currency : '€'}>{product.price}</Price></span>
						</div>}
					</div> : <div className="absolute right-1 bottom-1 left-1">
						<Link to={`/login/?referrer=/product/${product.map_id}`}> <Button fluid basic>{translate("Preise anzeigen")}</Button></Link>
					</div>
					}
				</div>

				{useQuickorder &&
				<div className="QuickorderTab flex flex-auto pt3 mb3" style={{justifyContent: "space-between"}}>
					<div className="quickorder-count">
						{inCart.count * inCart.unit_multi} <br />
						{translate( "piece" )}
					</div>

					<div className="quickorder-input">
						<Input value={inCart.count} />
					</div>

					<div className="quickorder-actions">
						<Button floated="right" icon="plus" onClick={() => {
							if ( inCart.count ) {
								inCart.count += 1
							} else {
								inCart.count = 1
							}
							shop.cart.add( inCart )
						}
						} /><Button floated="right" icon="minus" onClick={() => {
						if ( inCart.count > 0 ) {
							inCart.count -= 1
						} else {
							inCart.count = 0
						}
						shop.cart.add( inCart )
					}
					} />
					</div>

				</div>}

			</Card>
		)
	}
}

ProductCard.defaultProps = {
	quickorder: false
}

ProductCard.propTypes = {
	quickorder: PropTypes.any,
	list      : PropTypes.object,
	product   : PropTypes.object,
	xs        : PropTypes.string,
	sm        : PropTypes.string,
	md        : PropTypes.string,
	lg        : PropTypes.string,
}

export default ProductCard



// WEBPACK FOOTER //
// ./src/components/Product/ProductCard.js